import { UnRegisterContractAction } from "./types";

export const getSkuOptions = (payload = {}) =>
  ({
    type: UnRegisterContractAction.GET_SKUsOPTIONS,
    payload,
  }) as const;

export const setSKUsOPTIONS = (payload) =>
  ({
    type: UnRegisterContractAction.SET_SKUsOPTIONS,
    payload,
  }) as const;

export const cleanUpUnRegisterContract = () => ({
  type: UnRegisterContractAction.CLEAN_UP,
});

export const createUnRegisterContract = (
  payload: any,
  dealerId: any,
  callback: () => void = () => {}
) =>
  ({
    type: UnRegisterContractAction.CREATE_UNREGISTER_CONTRACT,
    payload,
    dealerId,
    callback,
  }) as const;

export const uploadDocuments = (files: File[], dealerId, callback = () => {}) =>
  ({
    type: UnRegisterContractAction.UPLOAD_DOCUMENTS,
    files,
    dealerId,
    callback,
  }) as const;

export const setUploadedDocuments = (payload: any) =>
  ({
    type: UnRegisterContractAction.SET_UPLOADED_DOCUMENTS,
    payload,
  }) as const;
